module.exports = __webpack_public_path__ + "static/media/contentNew.f912fd33.svg";